import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DecimalPipe, NgClass } from '@angular/common';
import { TuiButtonModule } from '@taiga-ui/core';
import { isNil } from 'lodash';
import { FormatNumberPipe } from '@us/web/shop/data-access';

@Component({
    selector: 'us-number-group',
    standalone: true,
    imports: [TuiButtonModule, DecimalPipe, NgClass, FormatNumberPipe],
    templateUrl: './number-group.component.html',
    styleUrls: ['./number-group.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NumberGroupComponent {
    @Input() value = 0;
    @Input() size: 's' | 'm' | 'l' | 'xs' = 's';
    @Input() minimumQuantity = 0;
    @Input() maximumQuantity: number = Number.MAX_VALUE;
    @Input() className = '';
    @Input() classNameSpan = '';

    @Output() decreaseQuantityClick = new EventEmitter<void>();
    @Output() increaseQuantityClick = new EventEmitter<void>();

    get decreaseQuantityBtnDisabled() {
        return !isNil(this.minimumQuantity) && this.value <= this.minimumQuantity;
    }

    get increaseQuantityBtnDisabled() {
        return !isNil(this.maximumQuantity) && this.value >= this.maximumQuantity;
    }

    handleClickDecreaseQuantity(e?: MouseEvent) {
        e?.stopPropagation();
        this.decreaseQuantityClick.emit();
    }

    handleClickIncreaseQuantity(e?: MouseEvent) {
        e?.stopPropagation();
        this.increaseQuantityClick.emit();
    }
}
